<template>
    <div class="card flex-column flex-lg-row w-100 h-100" id="Personal__Help">
        <div class="d-flex flex-column justify-content-center flex-grow-1 p-2">
            <div class="fw-bold font-size-md mb-1">
                Search our Help Center
                <div class="input-group" :class="{ 'has-value': !!enableSearch }">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Type and Click Search"
                        @keyup.enter="enterKeyPress"
                        v-model="helpSearch"
                    />
                    <div class="input-group-append">
                        <button class="btn clear-search" v-show="enableSearch" @click="clearSearch">
                            <i class="fas fa-times"></i>
                        </button>
                        <button class="btn btn-primary" :disabled="!enableSearch" @click="helpCenterSearch">
                            <i class="fas fa-search me-1"></i>
                            Search
                        </button>
                    </div>
                </div>
            </div>
            <a href="https://www.axxess.com/help/" target="_blank" class="align-self-start ps-1">
                Visit Axxess Help Center
            </a>
            <a
                href="https://www.axxess.com/help/search/?q=having%20trouble%20logging%20in"
                target="_blank"
                class="align-self-start ps-1"
            >
                Having Trouble Logging In?
            </a>
        </div>
        <a href="https://community.axxessweb.com/" target="_blank" class="community-link">
            <img src="../../../../../img/speech-bubble.svg" />
            <div class="ms-2 d-flex flex-column justify-content-center text-white">
                <span class="fw-md fw-bold"> Axxess Community </span>
                <span> Speak with fellow Axxessians </span>
            </div>
        </a>
    </div>
</template>

<script lang="ts" src="./PersonalHelp.ts"></script>
<style src="./PersonalHelp.scss"></style>
